import "../css/main.css";

import { GitHub, Linkedin, Download } from "react-feather";

const Home = () => {
    return (
        <div className="home-section">
            <div className="left-side-content">
                <div className="main-intro-text">
                    <h1 className="left-name">Desmond Virasak-Holmes</h1>
                    <h1 className="left-position">Software Developer</h1>
                    <h1 className="left-description">Building innovative software.</h1>
                    <p className="left-subtitle">
                        I build clean, reliable web applications with React, TypeScript, and modern DevOps tools, while exploring full-stack
                        and data-driven development. I enjoy crafting polished UIs, automating workflows, and learning technologies that
                        make systems simpler and faster.
                    </p>
                </div>
                <div className="main-buttons-section">
                    <div className="main-buttons-section">
                        <div className="icon-wrap" onClick={() => window.open("https://www.linkedin.com/in/dvholmes8219/", "_blank")}>
                            <Linkedin />
                        </div>
                        <div className="icon-wrap" onClick={() => window.open("https://github.com/dvholmes", "_blank")}>
                            <GitHub />
                        </div>
                    </div>
                </div>
                <div className="resume-button-container">
                    <button
                        className="resume-button"
                        onClick={() => {
                            const link = document.createElement("a");
                            link.href = "./skill_tools/DHResume.pdf";
                            link.download = "Desmond_Virasak-Holmes_Resume.pdf";
                            link.click();
                        }}
                    >
                        Resume
                        <Download className="resume-icon" />
                    </button>
                </div>
            </div>
            <div className="right-side-content">
                <img src="dvholmes4.png" alt="Desmond Virasak-Holmes" />
            </div>
        </div>
    );
};

export default Home;
